module.exports = {"cashier":"cashier","kioskWelcome":"Thank you for registering."}


//////////////////
// WEBPACK FOOTER
// ./src/static/strings.json
// module id = 616
// module chunks = 0